<template>
	<c-dialog ref="dialog" :title="title" width="1000" height="800" enable-flex :button="false">
        <c-table ref="table" height="770" :paging="false">
			<c-table-column label="链路层级" name="rn" width="60">
			    <template v-slot="{data}">
			        {{data.rn}}级
			    </template>
			</c-table-column>

            <c-table-column
                    label="手机号"
                    name="user_manage_mobilephone"
                    width="120"
            >
                <template v-slot="{data}">
                    <span v-if="data.user_manage_mobilephone && data.user_manage_mobilephone!=''">{{ data.user_manage_mobilephone }}</span>
                    <span v-else>--</span>
                </template>
            </c-table-column>

            <c-table-column
                    label="头像/昵称"
                    name="head_photo"
                    width="180"
            >
                <template v-slot="{data}">
                    <div class="flex-center-cross">
                        <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                        <span>{{ data.nick_name }}</span>
                    </div>
                </template>
            </c-table-column>

            <c-table-column
                    label="等级"
                    name="user_level_name"
					width="80"
            >
                <template v-slot="{data}">
                    <span v-if="data.user_level_name" style="color:blue">{{ data.user_level_name }}</span>
                    <span v-else>普通会员</span>
                </template>
            </c-table-column>
			
			<!-- <c-table-column
				label="已结算业绩数量"
				name="performance_count"
				width="100"
			>
			</c-table-column>

            <c-table-column label="状态" name="state" width="40">
                <template v-slot="{data}">
                    <span v-if="data.state == 1" style="color:green">启用</span>
                    <span v-if="data.state == 2" style="color:red">禁用</span>
                </template>
            </c-table-column> -->
			
			<c-table-column
				label="注册时间"
				name="create_date"
				width="150"
			>
			</c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>
export default {
    props: {
        multiple: Boolean
    },
	data() {
	    return {
	        title:'会员邀请链路',
	        serachParams:{}
	    }
	},
    methods: {
        open(params) {
			this.serachParams = params||{};
			if (params && params.title){
			    this.title = params.title;
			}
			this.$refs.dialog.open();
			this.$refs.table.load({
			    url: '/platform_user/parent/list',
			    data:this.serachParams
			});
        }
    }
}
</script>